<div
  [ngClass]="isActive ? 'dropdown-content--active' : ''"
  class="dropdown-content"
>
  <ng-content></ng-content>
</div>

